import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Row } from 'reactstrap';
import StepOne from './steps/StepOne';
import StepTwo from './steps/StepTwo';
import StepThree from './steps/StepThree';

export function getStepFields(page) {
  switch (page) {
    case 1:
      return [
        'title',
        'code',
        'description',
        'isPlatformWide',
        'summary',
        'dataSkills',
        'dataOtherSkills',
        'moduleType',
      ];
    case 2:
      return ['imageUrl']; // 'prerequisiteModule'
    case 3:
      return ['courses'];
    default:
      return [];
  }
}

export function extractFieldData(page, data) {
  const obj = {};
  getStepFields(page).forEach((key) => (obj[key] = data[key]));
  return obj;
}

const ModuleWizardForm = ({
  onSubmit,
  data,
  setData,
  initialValues,
  id,
  setPrerequisiteModulesList,
  prerequisiteModulesList,
  courseList,
  setCourseList,
  state,
}) => {
  const [page, setPage] = useState(1);

  const nextPage = (newData) => {
    setData({ ...data, ...newData });
    setPage(page + 1);
  };

  const previousPage = (newData) => {
    setData({ ...data, ...newData });
    setPage(page - 1);
  };

  const clearForm = () => {
    setData(initialValues);
    setPage(1);
  };

  const submitHandler = (newData) => {
    const dataToSubmit = { ...data, ...newData };
    setData(dataToSubmit);
    onSubmit(dataToSubmit, clearForm);
  };

  return (
    <Row>
      <Col md={12} lg={12}>
        <Card className="pb-0">
          <CardBody className="wizard">
            <div className="wizard__steps">
              <div className={`wizard__step${page === 1 ? ' wizard__step--active' : ''}`}>
                <p>Step 1</p>
              </div>
              <div className={`wizard__step${page === 2 ? ' wizard__step--active' : ''}`}>
                <p>Step 2</p>
              </div>
              <div className={`wizard__step${page === 3 ? ' wizard__step--active' : ''}`}>
                <p>Step 3</p>
              </div>
            </div>
            <div className="wizard__form-wrapper">
              {page === 1 && <StepOne page={page} onSubmit={nextPage} data={data} id={id} />}
              {page === 2 && (
                <StepTwo
                  page={page}
                  setPrerequisiteModulesList={setPrerequisiteModulesList}
                  prerequisiteModulesList={prerequisiteModulesList}
                  id={id}
                  previousPage={previousPage}
                  onSubmit={nextPage}
                  data={data}
                  onClear={clearForm}
                />
              )}
              {page === 3 && (
                <StepThree
                  page={page}
                  setCourseList={setCourseList}
                  courseList={courseList}
                  id={id}
                  previousPage={previousPage}
                  onSubmit={submitHandler}
                  data={data}
                  state={state}
                />
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

ModuleWizardForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default ModuleWizardForm;
